import { FormBase } from 'core/components';

export default class BulkPrintForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				'fulfillmentOrders',
				'fulfillmentOrders[].id',
				'fulfillmentOrders[].box',
				'fulfillmentOrders[].isBoxRequired',
			],
			labels: {
				'fulfillmentOrders[].box': 'FULFILLMENTORDER.BULKPRINT.BOXDIMENSIONS',
			},
		};
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/BulkPrintForm.js